@if (isPaying) {
    <app-spinner-overlay
        [showSpinner]="isPaying"
    >
    </app-spinner-overlay>
}
<div
    class="row g-0"
    [formGroup]="form"
    [ngClass]="{'Ryft--payform': isRyftPayment}"
>
    <div class="col-md-7">
        <div class="vstack gap-3 px-4 py-3 pb-4 px-lg-5 py-lg-4 mb-auto">
            <div class="d-flex align-items-center gap-2 small">
                <span
                    class="badge rounded-pill"
                    [ngClass]="deliveryStepActive ? 'text-bg-dark' : 'text-bg-light text-body border'"
                >
                    1
                </span>
                <span
                    [ngClass]="deliveryStepActive ? 'fw-semibold text-body' : 'text-muted'"
                >
                    Delivery
                </span>
                <span class="border-top flex-grow-1"></span>
                <span
                    class="badge rounded-pill"
                    [ngClass]="paymentStepActive ? 'text-bg-dark' : 'text-bg-light text-body border'"
                >
                    2
                </span>
                <span
                    [ngClass]="paymentStepActive ? 'fw-semibold text-body' : 'text-muted'"
                >
                    Payment
                </span>
            </div>
            @if (deliveryStepActive) {
                <ng-container
                    *ngTemplateOutlet="shippingDetails"
                >
                </ng-container>
            } @else {
                <ng-container
                    *ngTemplateOutlet="paymentDetails"
                >
                </ng-container>
            }
        </div>
    </div>
    <div class="col-md-5 bg-light">
        <div class="px-4 py-3 pb-4 px-lg-5 py-lg-4 pb-lg-5">
            <ng-container
                *ngTemplateOutlet="productSummary"
            >
            </ng-container>
        </div>
    </div>
</div>

<ng-template
    #productSummary
>
    <div class="vstack gap-2 flex-grow-0">
<!--        <div class="card">-->
<!--            <div class="card-body">-->
                <div class="vstack gap-1">
                    <h6 class="fw-semibold m-0">
                        Order Summary
                    </h6>
                    <hr class="border-dark-subtle my-2"/>
                    <div class="hstack gap-2 justify-content-between">
                    @if (selectedSKU) {
                        <span>
                            {{ voucher.displayName }}
                            {{ null  | currencyUnit : selectedSKUVoucherAmount : venue.currencyCode }}
                            x{{ quantity }}
                        </span>
                        <span>
                            {{ null | currencyUnit : selectedSKU.price * quantity : venue.currencyCode }}
                        </span>
                    }
                    </div>
                    @if (postalDeliverySelected && voucher.postalDeliveryEnabled) {
                        <div class="hstack gap-2 justify-content-between">
                            <span>
                                Postal delivery
                            </span>
                            <span>
                                {{ null | currencyUnit : selectedPostalDeliveryFee : venue.currencyCode }}
                            </span>
                        </div>
                    }
                    <hr class="border-dark-subtle my-2"/>
                    <div class="vstack gap-1">
                        <div class="hstack justify-content-between">
                            <span>
                                Subtotal
                            </span>
                            <span>
                                {{ null | currencyUnit : selectedTotalPrice : venue.currencyCode }}
                            </span>
                        </div>
                        <div class="hstack justify-content-between">
                            <span class="fw-semibold">
                                Total
                            </span>
                            <span class="fw-semibold">
                                {{ null | currencyUnit : selectedTotalPrice : venue.currencyCode }}
                            </span>
                        </div>
                    </div>
                </div>
                @if (expiryDate) {
                    <hr class="border-dark-subtle my-2"/>
                    <div class="vstack gap-2 flex-grow-0">
                        <span class="text-muted small">
                            This voucher is valid for use at
                            {{ venue.voucherDisplayName() }} until the end of
                            {{ expiryDate | date }}.
                        </span>
                    </div>
                }
                @if (voucher.policy && voucher.policy.length > 0) {
                    <hr class="border-dark-subtle my-2"/>
                    <div class="vstack gap-2 flex-grow-0">
                        <span class="text-muted small">
                            By placing an order for this voucher, you agree to
                            {{ venue.voucherDisplayName() }}'s
                            Terms & Conditions:
                        </span>
                        <ul class="list-group">
                            <a
                                class="list-group-item list-group-item-action hstack justify-content-between"
                                role="button"
                                (click)="showPolicy()"
                            >
                                <span class="fw-semibold">
                                    Terms & Conditions
                                </span>
                                <img
                                    ngSrc="assets/right/normal.svg"
                                    width="16"
                                    height="16"
                                    alt="Terms & Conditions"
                                >
                            </a>
                        </ul>
                    </div>
                }
<!--            </div>-->
<!--        </div>-->
    </div>
</ng-template>

<ng-template
    #shippingDetails
>
    <div
        class="flex-grow-0"
        [formGroup]="checkoutForm"
    >
        <div class="vstack gap-3">
            <div class="form-group">
                <div class="row g-2">
                    @if (voucher.postalDeliveryEnabled) {
                        <div class="col-12">
                            <div class="vstack gap-2">
                                <span class="fw-semibold">
                                    How should we deliver it?
                                </span>
                                <div
                                    class="d-flex btn-group segmented-control justify-content-evenly w-100"
                                    role="group"
                                    aria-label="Delivery method"
                                >
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        id="deliveryMethodEmail"
                                        autocomplete="off"
                                        formControlName="deliveryMethod"
                                        value="EMAIL"
                                    >
                                    <label
                                        class="btn btn-outline-primary flex-fill hstack gap-2 align-items-center justify-content-center"
                                        for="deliveryMethodEmail"
                                    >
                                        <img
                                            ngSrc="assets/mail/normal.svg"
                                            width="20"
                                            height="20"
                                            alt=""
                                            aria-hidden="true"
                                        >
                                        <span>
                                            Email
                                        </span>
                                    </label>
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        id="deliveryMethodPostal"
                                        autocomplete="off"
                                        formControlName="deliveryMethod"
                                        value="POSTAL"
                                    >
                                    <label
                                        class="btn btn-outline-primary flex-fill hstack gap-2 align-items-center justify-content-center"
                                        for="deliveryMethodPostal"
                                    >
                                        <img
                                            ngSrc="assets/inbox/normal.svg"
                                            width="20"
                                            height="20"
                                            alt=""
                                            aria-hidden="true"
                                        >
                                        <span>
                                            Post
                                        </span>
                                        @let postalFee = voucher.postalDeliveryFee ?? 0;
                                        @if (postalFee > 0) {
                                            ({{ null | currencyUnit : postalFee : venue.currencyCode }})
                                        }
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <hr class="border-dark-subtle my-1"/>
                        </div>
                    }
                    @if (!postalDeliverySelected) {
                        <div class="col-12">
                            <div class="input-group has-validation gap-2">
                                <label
                                    for="email"
                                    class="form-label"
                                >
                                    Recipient Email Address
                                </label>
                            </div>
                            <input
                                type="email"
                                class="form-control"
                                id="email"
                                formControlName="deliveryEmailAddress"
                                placeholder="Recipient email address"
                                [ngClass]="{
                                    'is-invalid': deliveryEmailAddressControl.invalid && deliveryEmailAddressControl.touched
                                }"
                            >
                        </div>
                    }
                    @if (!postalDeliverySelected) {
                        <div class="col-12">
                            <div class="input-group has-validation gap-2">
                                <label
                                    for="recipientName"
                                    class="form-label"
                                >
                                    Recipient Name (Optional)
                                </label>
                            </div>
                            <input
                                type="text"
                                class="form-control"
                                id="recipientName"
                                formControlName="recipientName"
                                placeholder="Recipient name"
                                [ngClass]="{
                                    'is-invalid': recipientNameControl.invalid && recipientNameControl.touched
                                }"
                            >
                        </div>
                    }
                    @if (postalDeliverySelected) {
                        <div class="col-12">
                            <span class="form-label fw-semibold mb-0">
                                Postal address
                            </span>
                        </div>
                        <div class="col-12">
                            <input
                                type="text"
                                class="form-control"
                                id="recipientName"
                                formControlName="recipientName"
                                placeholder="Recipient name"
                                aria-label="Recipient name"
                                autocomplete="name"
                                [ngClass]="{
                                    'is-invalid': recipientNameControl.invalid && recipientNameControl.touched
                                }"
                            >
                        </div>
                        <div class="col-12">
                            <input
                                type="text"
                                class="form-control"
                                id="addressLineOne"
                                formControlName="addressLineOne"
                                placeholder="Address line 1"
                                aria-label="Address line 1"
                                autocomplete="address-line1"
                                [ngClass]="{
                                    'is-invalid': addressLineOneControl.invalid && addressLineOneControl.touched
                                }"
                            >
                        </div>
                        <div class="col-12">
                            <input
                                type="text"
                                class="form-control"
                                id="addressLineTwo"
                                formControlName="addressLineTwo"
                                placeholder="Address line 2 (optional)"
                                aria-label="Address line 2"
                                autocomplete="address-line2"
                            >
                        </div>
                        <div class="col-md-6">
                            <input
                                type="text"
                                class="form-control"
                                id="city"
                                formControlName="city"
                                placeholder="City / locality"
                                aria-label="City or locality"
                                autocomplete="address-level2"
                                [ngClass]="{
                                    'is-invalid': cityControl.invalid && cityControl.touched
                                }"
                            >
                        </div>
                        <div class="col-md-6">
                            <input
                                type="text"
                                class="form-control"
                                id="county"
                                formControlName="county"
                                placeholder="County / region (optional)"
                                aria-label="County or region"
                                autocomplete="address-level1"
                            >
                        </div>
                        <div class="col-md-6">
                            <input
                                type="text"
                                class="form-control"
                                id="postCode"
                                formControlName="postCode"
                                placeholder="Postal / ZIP code"
                                aria-label="Postal or ZIP code"
                                autocomplete="postal-code"
                                [ngClass]="{
                                    'is-invalid': postCodeControl.invalid && postCodeControl.touched
                                }"
                            >
                        </div>
                        <div class="col-md-6">
                            <input
                                type="text"
                                class="form-control"
                                id="country"
                                formControlName="country"
                                placeholder="Country"
                                aria-label="Country"
                                autocomplete="country-name"
                                [ngClass]="{
                                    'is-invalid': countryControl.invalid && countryControl.touched
                                }"
                            >
                        </div>
                        @if (checkoutForm.errors?.['postalAddressIncomplete'] && checkoutForm.touched) {
                            <div class="col-12 text-danger small">
                                Please enter enough address details for the voucher to be posted.
                            </div>
                        }
                    }
                    <div class="col-12">
                        <hr class="border-dark-subtle my-1"/>
                        <span class="form-label fw-semibold mb-0">
                            Gift message
                        </span>
                    </div>
                    <div class="col-12">
                        <quill-editor
                            class="w-100 border rounded"
                            style="border-color: color-mix(var(--bs-dark), var(--bs-body-bg) 93%) !important"
                            formControlName="senderMessage"
                            theme="bubble"
                            placeholder="Add a personal message for the recipient (Optional)"
                            [modules]="{ toolbar: recipientMessageToolbarOptions }"
                            [trimOnValidation]="true"
                        >
                        </quill-editor>
                    </div>
                </div>
            </div>
            <button
                class="btn btn-primary"
                type="button"
                appVenueColour
                [primaryColour]="venue.primaryColour"
                (click)="goToPaymentStep()"
            >
                Continue to payment
            </button>
        </div>
    </div>
</ng-template>

<ng-template
    #paymentDetails
>
    <div
        class="vstack gap-3"
        [formGroup]="checkoutForm"
    >
        <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-2">
            <button
                class="btn btn-outline-secondary btn-sm hstack gap-2 align-items-center"
                type="button"
                (click)="goToDeliveryStep()"
            >
                <img
                    ngSrc="assets/left/normal.svg"
                    width="20"
                    height="20"
                    alt="Back to delivery"
                >
            </button>
            <h6 class="fw-semibold m-0">
                Payment Details
            </h6>
        </div>
        <div class="vstack gap-2">
            <div class="form-group">
                <div class="input-group has-validation gap-2">
                    <label
                        for="billingEmailAddress"
                        class="form-label text-muted-subtle mb-1"
                    >
                        Billing Email Address
                    </label>
                </div>
                <input
                    type="email"
                    class="form-control"
                    id="billingEmailAddress"
                    formControlName="billingEmailAddress"
                    placeholder="The email address for the receipt"
                    [ngClass]="{
                        'is-invalid': billingEmailAddressControl.invalid && billingEmailAddressControl.touched
                    }"
                />
            </div>
            <hr class="border-dark-subtle my-1"/>
            <div
                id="payment-apple-wallet-button"
                [hidden]="!walletPaymentAvailable"
            >
            </div>
            <div
                id="payment-google-wallet-button"
                [hidden]="!walletPaymentAvailable"
            >
            </div>
            <div
                id="payment-card-form"
                [style.min-height.px]="230"
            >
            </div>
            <div
                *ngIf="isRyftPayment"
                class="small text-muted"
            >
                Enter your card details to continue.
            </div>
            <hr class="border-dark-subtle my-1"/>
            <div class="form-check hstack gap-2 align-items-center mt-1">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="agreedToTerms"
                    formControlName="agreedToTerms"
                    data-testid="agreed-to-terms"
                    [ngClass]="{
                    'is-invalid': agreedToTermsControl.invalid && agreedToTermsControl.touched
                }"
                >
                <label for="agreedToTerms">
                    I have read and accept the TableSense
                    <a class="text-body" [href]="privacyPolicyURL" target="_blank">Privacy Policy</a>
                    agreement
                    <span
                        *ngIf="agreedToTermsControl.invalid && agreedToTermsControl.touched"
                        class="text-danger small"
                    >
                    You need to accept the Privacy Policy to continue with the purchase
                </span>
                </label>
            </div>
        </div>
        <button
            class="btn btn-primary"
            appVenueColour
            [primaryColour]="venue.primaryColour"
            [disabled]="isPaying || !paymentSession || checkoutForm.invalid || form.invalid || (isRyftPayment && !cardDetailsAreComplete)"
            (click)="pay()"
        >
            Pay {{ null | currencyUnit : selectedTotalPrice : venue.currencyCode }}
        </button>
    </div>
</ng-template>
